import React from 'react';
import { Box, Typography } from '@mui/material';
import StaffAvailability from '../components/StaffAvailability';

const StaffAvailabilityPage = () => {
    return (
        <Box sx={{
            width: '100%',
            height: '100vh',
            bgcolor: '#121212',
            color: '#e0e0e0',
            pt: 8, // Account for fixed top menu bar
            overflow: 'hidden'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                px: 3 // Add padding to header
            }}>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#ffffff' }}>
                    Staff Availability
                </Typography>
            </Box>

            <Box sx={{
                height: 'calc(100vh - 140px)',
                overflow: 'hidden'
            }}>
                <StaffAvailability />
            </Box>
        </Box>
    );
};

export default StaffAvailabilityPage;
